var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_vm._l((_vm.consegne),function(consegna){return [_c('ConsegnaEl',{key:consegna.id,attrs:{"consegna":consegna}}),_c('v-divider',{key:consegna.id + '-div'})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }